import * as API from './api'
import * as Types from './Types'

export function setSelectedCommunity(id) {
  return dispatch => {
    dispatch({
      type: Types.SET_SELECTED_COMMUNITY,
      payload: id
    })
  }
}

export function showSelectCommunityModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_SELECT_COMMUNITY_MODAL
    })
  }
}

export function hideSelectCommunityModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_SELECT_COMMUNITY_MODAL
    })
  }
}

export function tryGetCommunity(token) {
  return dispatch => {
    dispatch({
      type: Types.GET_COMMUNITY
    })

    API.getCommunity(token)
      .then(response => {
        dispatch({
          type: Types.GET_COMMUNITY_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.GET_COMMUNITY_FAILED,
          payload: status
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Communities.js